export default __webpack_public_path__ + "static/media/i088jk.bf1a3ab9.webp";